module.exports = "<div> <group title=Toast> <group-item title=loading right-desc=点击出弹窗 @click=triggerLoadingToast></group-item> <group-item title=warning right-desc=点击出弹窗 @click=triggerWarningToast></group-item> <group-item title=success right-desc=点击出弹窗 @click=triggerSuccessToast></group-item> </group> <toast :show=loadingToast.show :text=loadingToast.text></toast> <toast :show=warningToast.show :text=warningToast.text :type=warningToast.type></toast> <toast :show=successToast.show :text=successToast.text :type=successToast.type></toast> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/demos/Toast.vue
 ** module id = 203
 ** module chunks = 0
 **/